<!-- Floating pill navigation: one rounded bar, swipeable icons, edge arrows, -->
<!-- the active destination is highlighted in-place (no separate container). -->
<nav class="navpill" role="navigation" aria-label="Main navigation">
	<button
		type="button"
		class="navpill__arrow navpill__arrow--left"
		[class.is-hidden]="!canNavLeft()"
		(click)="scrollNav(-1)"
		[attr.aria-label]="'nav.scrollLeft' | translate"
	>
		<mat-icon>chevron_left</mat-icon>
	</button>

	<div class="navpill__track" #navTrack (scroll)="onNavScroll()">
		@for (item of allNav; track item.path; let i = $index) {
		<a
			class="navpill__item"
			[class.active]="i === activeIndex()"
			[class.locked]="isLocked(item)"
			[routerLink]="item.path"
			(click)="onNavClick(i)"
		>
			<mat-icon>{{ item.icon }}</mat-icon>
			<span class="navpill__lbl">
				{{ item.labelKey ? (item.labelKey | translate) : item.label }}
			</span>
			@if (isLocked(item)) {
			<mat-icon class="navpill__lock">lock</mat-icon>
			}
		</a>
		}
		<!-- „Menu” to zakładka (strona z siatką ikon), nie wysuwany panel nad paskiem. -->
		<a
			class="navpill__item navpill__more"
			[class.active]="naMenu()"
			[routerLink]="menuPath"
			(click)="onMenuElementClick()"
		>
			<mat-icon>apps</mat-icon>
			<span class="navpill__lbl">{{ 'nav.more' | translate }}</span>
		</a>
	</div>

	<button
		type="button"
		class="navpill__arrow navpill__arrow--right"
		[class.is-hidden]="!canNavRight()"
		(click)="scrollNav(1)"
		[attr.aria-label]="'nav.scrollRight' | translate"
	>
		<mat-icon>chevron_right</mat-icon>
	</button>
</nav>
